import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as R from 'ramda';
import { updateOnBoardingStep, processPayment, getCurrentPrices } from '../../../actions/user-api';
import * as Loadings from '../../../constants/loadings/user';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentMethods } from '../../../_common/payments2';
import { DiscountCode } from './discountCode';
import featuresOverview from './../../../assets/images/placeholder/Features-Overview.svg';
import { LoadingState } from '../../../_common/loadingState';
import queryString from 'query-string';

export const Step6 = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const [userAge, setUserAge] = useState(0);
    const [paymentType, setPaymentType] = useState(0);

    const prices = [{ num: 1, price: '299,00' }, { num: 4, price: '74,75' }, { num: 6, price: '49,95' }, { num: -1, price: '29,99' }];
    const [paymentOptions, setPaymentOptions] = useState({
        prices: prices,
        selectedOption: prices[0],
        hasLoadedPrices: false
    });


    const [processing, setProcessing] = useState(false);
    const [discountCodeState, setDiscountCodeState] = useState({
        code: undefined,
        apiId: undefined,
        isValid: undefined,
    });

    useEffect(() => {
        setUserAge(getAge(user.user.birthDate));
    }, []);

    useEffect(() => {

        getCurrentPrices(user.user.id)
            .then((prices) => {
                let mappedPrices = prices.map((price) => {
                    if (price.product === "SetupFee1Minus65" && userAge < 65) {
                        return { num: 1, price: price.currentPrice.toFixed(2) };
                    }
                    if (price.product === "SetupFee1" && userAge >= 65) {
                        return { num: 1, price: price.currentPrice.toFixed(2) };
                    }
                    if (price.product === "SetupMonthly") {
                        return { num: 12, price: price.currentPrice.toFixed(2) };
                    }
                    if (price.product === "SetupFee4") {
                        return { num: 4, price: price.currentPrice.toFixed(2) };
                    }
                    if (price.product === "SetupFee6") {
                        return { num: 6, price: price.currentPrice.toFixed(2) };
                    }
                    if (price.product === "Annual") {
                        return { num: -1, price: price.currentPrice.toFixed(2) };
                    }
                }).filter(e => !R.isNil(e));

                mappedPrices = R.sortBy(R.prop('num'))(mappedPrices);
                setPaymentOptions({ ...paymentOptions, prices: mappedPrices, selectedOption: mappedPrices.find(p => p.num === 1), hasLoadedPrices: true });
            });


    }, [userAge]);

    function getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }


    async function endRegistration() {
        setProcessing(true);
        if (!user.user.billedByPartner && !user.user.hasHrDocuments) {
            await dispatch(processPayment(user.user, discountCodeState.apiId, paymentOptions.selectedOption.num));
        }
        await dispatch(updateOnBoardingStep(6));
        let tmpUser = user.user;
        let step = !R.isNil(user) && !R.isNil(tmpUser) && !R.isNil(tmpUser.onBoardingStep) ? parseInt(JSON.stringify(tmpUser.onBoardingStep).replace(/\D/g, "")) : -1;
        if (step === 6 || step === -1) {
            if (tmpUser.onBoardingStep === "Completed" || tmpUser.onBoardingStep === 6) {
                setProcessing(false);

                const parsedQueryString = queryString.parse(window.location.search);
                if (!R.isNil(parsedQueryString.redirect_uri) && !R.isNil(parsedQueryString.nonce) && !R.isNil(parsedQueryString.state)) {
                    const search = {
                        state: parsedQueryString.state,
                        nonce: parsedQueryString.nonce,
                        externalUserId: user.user.id
                    };
                    window.location = parsedQueryString.redirect_uri + "?" + queryString.stringify(search);
                    return;
                }

                window.location = `/anticipa?fc=1`;
            }
        }
    }
    if (R.isNil(user.user) || !paymentOptions.hasLoadedPrices) {
        return <LoadingState />;
    }


    if (user.user.billedByPartner || user.user.hasHrDocuments) {
        return (
            <article className="view-calc mb-auto pt-3">
                <div className="auto-view my-auto">
                    <div className="container-fluid">
                        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-gutter text-center">
                            <img className="img-fluid mx-auto container-md-press mb-gutter" src={featuresOverview} alt="features overview" />
                            <div className="container-default mx-auto">
                                <h1 className="text-primary font-weight-bolder mt-0 mb-1">Validation</h1>
                                <p className="h3 mb-0">Résumé de votre dossier.</p>
                            </div>
                        </header>
                        <section className="block container-default mx-auto">
                            {/* <h4 className="fs-3 text-uppercase font-weight-bolder mt-0">Deux formules au choix :</h4> */}
                            {/* <h3 className="h3 font-weight-bolder mt-3 mb-2">Votre dossier comprend :</h3> */}
                            <div className="card border-0">
                                {/* uncomment bellow to display 2 types of tarif */}
                                {/* <div className="card-header bg-light">
                                    <button type="button" className="btn btn-block btn-white-primary text-primary flex-row justify-content-between gap-2 px-3" id="dropdownMenuServiceoptions" data-toggle="dropdown" data-reference="parent">
                                        <span className="align-middle">Tarif A</span> <i className="align-middle eva eva-chevron-down-outline fs-sm lh-1 o-66"></i>
                                    </button>
                                    <ul className="dropdown-menu z-max border-none shadow p-2 w-100" aria-labelledby="dropdownMenuServiceoptions">
                                        <li><button className="dropdown-item rounded px-3 fs-3"><i className="eva eva-arrow-right mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Tarif A</span></button></li>
                                        <li><button className="dropdown-item rounded px-3 fs-3"><i className="eva eva-arrow-right mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Tarif B</span></button></li>
                                    </ul>
                                </div> */}
                                <div className="card-body">
                                    <div role="button" className="d-flex align-items-start small">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Création de votre dossier personnalisé</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Archivage dans un coffre-fort numérique sécurisé</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Suivi et courrier d’information annuel de votre dossier personnalisé</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Modification de vos données incluses</span>
                                    </div>
                                    <div role="button" className="d-flex align-items-start small mt-2">
                                        <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                        <span className="o-80">Confirmation des coordonnées de votre (vos) référent(s) annuellement</span>
                                    </div>
                                    {
                                        user.user.hasHrDocuments ?
                                            <>
                                                <div role="button" className="d-flex align-items-start small mt-2">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Création, copie et adressage en recommandé de tous les organismes en lien avec vous.</span>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <div role="button" className="d-flex align-items-start small mt-2">
                                                    <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                                    <span className="o-80">Intérruption de votre abonnement à tout moment</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small mt-2">
                                                    <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                                    <span className="o-80 font-weight-bolder">Accompagnement administratif dans les évènements de vie (déménagement ...)</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start small mt-2">
                                                    <i className="eva eva-checkmark-outline fs-sm mr-2 text-success"></i>
                                                    <span className="o-80">En cas de décès : <span className="font-weight-bolder">Création, copie et adressage de toutes vos démarches en recommandé</span></span>
                                                </div>
                                            </>
                                    }
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <footer className="block mt-auto mb-sm text-right w-100">
                    <div className="container-fluid flex-row align-items-center">
                        <Link to={"/auth/signup/step5" + (window.location.search !== '' ? window.location.search : '')} className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                        {
                            processing ?
                                <button className="btn btn-info px-md-gutter px-4 loading-btn show" disabled>Terminer <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                                :
                                <button className="btn btn-info px-md-gutter px-4 loading-btn" onClick={async () => {
                                    await endRegistration();
                                }}>Terminer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>

                        }
                    </div>
                </footer>
            </article>
        );
    }
    return (
        <article className="view-calc mt-3 mb-auto pt-3 mt-lg-n3 pt-lg-3">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-3">Validation</h1>
                    <h2 className="text-body ls-0 mt-n2 o-50">Résumé de votre dossier</h2>
                </header>
            </div>
            <div className="auto-view mt-3 mb-0">
                <div className="container-fluid h-100">
                    <section className="block">
                        <div className="row gx-2">
                            <div className="col-12 col-lg-4">
                                <h3 className="h3 text-secondary font-weight-bolder mt-3 mb-1">Mode de paiement</h3>
                                <p className="small o-80">Cliquez ci-dessous pour ajouter ou modifier une méthode de paiement</p>
                                <PaymentMethods user={user.user} loadings={user.isLoading} stripeClientSecret={user.stripeClientSecret} />
                                <hr className="my-gutter" />
                                <DiscountCode discountCodeState={discountCodeState} setDiscountCodeState={setDiscountCodeState} user={user.user} />
                            </div>
                            <div className="col-12 col-lg">
                                <div className="mw-100">
                                    <h3 className="h3 font-weight-bolder text-secondary mt-3 mb-2">{userAge < 65 && user.user.etablissementId === "00000000-0000-0000-0000-000000000000" ? "Deux formules au choix" : "Votre Formule"} :</h3>
                                    <div className="card border-0">
                                        {/* UI -- A */}
                                        {/* <button type="button" className="btn btn-block btn-white-primary text-primary flex-row justify-content-between gap-2 px-3" id="dropdownMenuServiceoptions" data-toggle="dropdown" data-reference="parent">
                                                <span className="align-middle">Tarif A</span> <i className="align-middle eva eva-chevron-down-outline fs-sm lh-1 o-66"></i>
                                            </button>
                                            <ul className="dropdown-menu z-max border-none shadow p-2 w-100" aria-labelledby="dropdownMenuServiceoptions">
                                                <li><button className="dropdown-item rounded px-3 fs-3"><i className="eva eva-arrow-right mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Tarif A</span></button></li>
                                                <li><button className="dropdown-item rounded px-3 fs-3"><i className="eva eva-arrow-right mr-2 fs-root align-middle"></i><span className="o-70 align-middle">Tarif B</span></button></li>
                                            </ul> */}
                                        {/* UI -- B */}
                                        {userAge < 65 && user.user.etablissementId === "00000000-0000-0000-0000-000000000000" ? (
                                            <div className="card-header bg-light">
                                                <div className="btn-group w-100" role="group" aria-label="...">
                                                    <button
                                                        type="button"
                                                        className={"btn btn-outline-primary font-weight-bold px-2 fs-root" + (paymentType === 1 ? " active" : "")}
                                                        onClick={(e) => {
                                                            setPaymentType(1);
                                                            let option = paymentOptions.prices.find((p) => p.num === 12);
                                                            if (option !== null) {
                                                                setPaymentOptions({ ...paymentOptions, selectedOption: option });
                                                            }
                                                        }}>
                                                        Simplicité
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={"btn btn-outline-primary font-weight-bold px-2 fs-root" + (paymentType === 0 ? " active" : "")}
                                                        onClick={(e) => {
                                                            setPaymentType(0);
                                                            let option = paymentOptions.prices.find((p) => p.num === 1);
                                                            if (option !== null) {
                                                                setPaymentOptions({ ...paymentOptions, selectedOption: option });
                                                            }
                                                        }}>
                                                        Liberté
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="card-header bg-light">
                                                <div className="btn-group w-100" role="group" aria-label="...">
                                                    <button type="button" className="btn btn-outline-primary font-weight-bold px-2 fs-root active">
                                                        Sérénité
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        <div className="card-body">
                                            <div className="block mb-sm">
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Création de votre dossier personnalisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Archivage dans un coffre-fort numérique sécurisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">
                                                        Accompagne dans vos évènements de vie : <b>déménagement</b>, passage à la majorité, mariage, naissance d'un enfant, divorce
                                                    </span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Suivi et courrier d’information annuel de votre dossier personnalisé</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Modification de vos données incluses</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Confirmation des coordonnées de votre (vos) référent(s) annuellement</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80 font-weight-bolder">Accompagnement administratif dans les évènements de vie (déménagement ...)</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">Intérruption de votre abonnement à tout moment</span>
                                                </div>
                                                <div role="button" className="d-flex align-items-start fs-aux">
                                                    <i className="eva eva-checkmark-outline h3 mr-2 text-success"></i>
                                                    <span className="o-80">
                                                        En cas de décès : <span className="font-weight-bolder">Création, copie et adressage de toutes vos démarches en recommandé</span>
                                                    </span>
                                                </div>
                                            </div>
                                            {/* <div className="d-flex align-items-start justify-content-between pb-1">
                                                <p className="h5 font-weight-normal my-auto">Organismes de bases</p>
                                                {
                                                    discountCodeState.isValid ?
                                                        <p className="h5 my-auto">0,00 €</p>
                                                    :
                                                        <p className="h5 my-auto">60,00 €</p>
                                                }
                                            </div>
                                            <div className="d-flex align-items-start justify-content-between pt-1">
                                                <p className="h5 font-weight-normal my-auto">Organismes complémentaires</p>
                                                {
                                                    discountCodeState.isValid ?
                                                        <p className="h5 my-auto">0,00 €</p>
                                                    :
                                                        <p className="h5 my-auto">239,00 €</p>
                                                }
                                            </div> */}
                                        </div>
                                        {paymentType === 0 ? (
                                            <div className="card-body pb-2 bg-common text-primary">
                                                <div className="d-flex align-items-start justify-content-between">
                                                    <p className="h6 font-weight-bolder my-auto">Total TTC</p>
                                                    {discountCodeState.isValid ? <p className="h2 font-weight-bolder my-auto">0,00 €</p> : <p className="h2 font-weight-bolder my-auto">{paymentOptions.prices.find((p) => p.num === 1).price} €</p>}
                                                </div>
                                                <hr className="o-10 border-primary" />
                                                <div className="d-flex align-items-start justify-content-between">
                                                    <p className="h6 text-body text-uppercase font-weight-bolder my-auto">PUIS</p>
                                                    <p className="h3 font-weight-bolder my-auto">{paymentOptions.prices.find((p) => p.num === -1).price} € par an</p>
                                                </div>
                                                <p className="small text-right mb-0 o-80">Pour l'actualisation et le suivi du dossier</p>
                                            </div>
                                        ) : (
                                            <div className="card-body pb-2 bg-common text-primary">
                                                <div className="d-flex align-items-start justify-content-between">
                                                    <p className="h6 font-weight-bolder my-auto">Total TTC</p>
                                                    {discountCodeState.isValid ? <p className="h2 font-weight-bolder my-auto">0,00 €</p> : <p className="h2 font-weight-bolder my-auto">{paymentOptions.prices.find((p) => p.num === 12).price} € / Mois</p>}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {discountCodeState.isValid || userAge < 65 || user.user.etablissementId === "00000000-0000-0000-0000-000000000000" ? (
                                        ""
                                    ) : (
                                        <div className="card border-0 bg-common text-primary mt-2">
                                            <div className="card-body py-3">
                                                <h5 className="h5 font-weight-bolder mb-3 pb-2 text-uppercase">Vous pouvez mensualiser votre dossier </h5>
                                                <form className="d-flex align-items-start justify-content-between">
                                                    <div className="form-inline w-50">
                                                        <select
                                                            className="form-control form-control-sm w-50 my-auto mr-sm-2 px-2 rounded py-0"
                                                            id="mois"
                                                            onChange={(e) => {
                                                                e.preventDefault();
                                                                let option = paymentOptions.prices.find((p) => p.num.toString() === e.target.value);
                                                                if (option !== null) {
                                                                    setPaymentOptions({ ...paymentOptions, selectedOption: option });
                                                                }
                                                            }}
                                                            value={paymentOptions.selectedOption.num}>
                                                            {paymentOptions.prices.map((option, index) => {
                                                                if (option.num !== -1 && option.num !== 12)
                                                                    return (
                                                                        <option key={index} value={option.num}>
                                                                            {option.num}
                                                                        </option>
                                                                    );
                                                            })}
                                                        </select>
                                                        {/* <input type="number" className="form-control form-control-sm w-50 my-auto mr-sm-2 px-2 rounded" id="mois" placeholder="3" /> */}
                                                        <label className="h6 font-weight-bolder my-auto text-body" htmlFor="mois">
                                                            mois
                                                        </label>
                                                    </div>
                                                    <p className="h2 font-weight-bolder my-auto">{paymentOptions.selectedOption.price} €</p>
                                                </form>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer className="block mt-auto text-right w-100 pt-4">
                        <div className="flex-row align-items-center">
                            <Link to="/auth/signup/step5" className="btn btn-faded px-md-gutter mr-3 ml-auto">
                                Retour
                            </Link>
                            {R.isEmpty(user.user.paymentMethods) && !discountCodeState.isValid ? (
                                <button className="btn btn-info px-md-gutter px-4" disabled>
                                    Payer maintenant
                                </button>
                            ) : user.isLoading.includes(Loadings.PROCESSING_PAYMENT) || processing ? (
                                <button className="btn btn-info px-md-gutter px-4 loading-btn show" disabled>
                                    Payer maintenant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                                </button>
                            ) : (
                                <button
                                    className="btn btn-info px-md-gutter px-4 loading-btn"
                                    onClick={async () => {
                                        await endRegistration();
                                    }}>
                                    Payer maintenant <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                                </button>
                            )}
                        </div>
                    </footer>
                </div>
            </div>
        </article>
    );
};